import React, {Component} from 'react'
import MessageList from "../MessageList/MessageList";
import {findmeChatroomChannel} from '../../websocket'
import TextareaAutosize from "react-textarea-autosize"
import _ from 'lodash'
import { result as browserResult } from '../../modules/common'
import Loading from '../../components/Loading/Loading'

// Import Scss
import './ChatRoom.scss'

class ChatRoom extends Component {
  constructor(props) {
    super(props)
    let chatStyle
    // スマホのフッターがvhに含まれないのでinnerHeightを使用する
    if (browserResult.mobile && props.mode === 'normal_chatroom') {
      let innerHeight = window.innerHeight
      chatStyle = {
        // TODO: refから高さ取得して計算させたい
        height: innerHeight - 125
      }
    }
    this.chatStyle = chatStyle || {}
  }

  componentDidMount() {
    if (this.props.chatRoom) {
      this.props.fetchMessages(this.props.chatroomId)
    }
    this.updateLastReadMessageId()

  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.chatRoom) {
      const lastPrevMessage = _.last(prevProps.chatRoom.findme_messages)
      const lastCurrentMessage = _.last(this.props.chatRoom.findme_messages)

      if (lastPrevMessage && lastCurrentMessage && lastPrevMessage.id !== lastCurrentMessage.id) {
        this.updateLastReadMessageId()
      }
    }
  }

  updateLastReadMessageId = () => {
    const { chatRoom } = this.props
    const lastMessage = chatRoom ? _.last(chatRoom.findme_messages) : null;
    if (!lastMessage) return
    const data = {
      message: {
        findme_chatroom_member_id: chatRoom.currentChatroomMemberId,
        last_read_message_id: lastMessage.id
      }
    }
    findmeChatroomChannel.updateLastReadMessageId(data)
  }

  submitChatMessage = () => {
    const {typing_message} = this.props.chatRoom
    if (!typing_message || typing_message.trim().length === 0) {
      this.props.updateTypingMessage("", this.props.chatRoom.id)
      return
    }
    const data = {
      message: {
        findme_chatroom_member_id: this.props.chatRoom.currentChatroomMemberId,
        findme_chatroom_id: this.props.chatRoom.id,
        message_type: "text",
        content: this.props.chatRoom.typing_message
      }
    }
    findmeChatroomChannel.speak(data)

    this.props.updateTypingMessage("", this.props.chatRoom.id)
  }

  onChatInputChange = (e) => {
    this.props.updateTypingMessage(e.target.value, this.props.chatRoom.id)
  }
  checkSubmit = (e) => {
    if (e.charCode === 13 && e.shiftKey) {

      // don't send message on enter on mobile
      if (browserResult.mobile) {
        return
      }

      this.submitChatMessage()
    }
  }

  loadMoreMessages = (chatroomId, from) => {
    if (this.props.chatRoom.reachedLastMessage) return
    this.props.loadMoreMessages(chatroomId, from)
  }

  render() {
    const props = this.props
    if (!props.chatRoom) return <Loading />
    return(
      <div className={`chatroom ${props.mode}`} style={this.chatStyle}>
        <MessageList
          loadMoreMessages={this.loadMoreMessages}
          mode={props.mode}
          messages={props.chatRoom.findme_messages || []}
          currentChatroomMemberId={props.chatRoom.currentChatroomMemberId}
        />
        <div className={`floating-support-chat__footer${props.chatRoom.typing_message ? ' typing': ''}`}>
          <div className="chat__footer">
            <div className="chat__footer-inner">
              <div className="form-group">
                <TextareaAutosize
                  value={props.chatRoom.typing_message || ""}
                  placeholder="ここにメッセージを入力"
                  onChange={this.onChatInputChange}
                  onKeyPress={this.checkSubmit}
                  className="form-control input-chat"
                  maxRows={3}
                />
              </div>
            </div>
          </div>
          <div className="input-control">
            <button
              className="btn-send-message"
              onClick={this.submitChatMessage}>
              送信
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default ChatRoom



// WEBPACK FOOTER //
// ./src/components/ChatRoom/ChatRoom.js